<ng-template [ngIf]="type === 'property'">
  <div class="availability-wrapper">
    <div
      class="availability"
      [class.sold-label]="property.availability === 'sold' || property.availability === 'reserved'"
    >
      {{ 'model.property.availability.' + property.availability | translate }}
    </div>
  </div>
  <div
    class="property-top"
    [ngStyle]="{'background-image': 'url(' + property.images[0].url + ')'}"
  >
  </div>
  <div
    class="property-bottom"
    fxLayout="column"
    fxLayoutAlign="center"
  >
    <!-- <div class="price-tag">
      <h3 *ngIf="property.for_sale && property.to_let == false">
        {{ property.sale_price | number:'.0-0' }} {{ 'model.currency_id.' + property.currency_id | translate }}
      </h3>
      <h3 *ngIf="property.to_let && property.for_sale == false">
        {{ property.let_price | number:'.0-0' }} {{ 'model.currency_id.' + property.currency_id | translate }}
      </h3>
      <h3 *ngIf="property.to_let && property.for_sale">
        {{ property.sale_price | number:'.0-0' }}
         {{ 'model.currency_id.' + property.currency_id | translate }}{{ property.let_price | number:'.0-0' }} {{ 'model.currency_id.' + property.currency_id | translate }}
      </h3>
    </div> -->
    <div
      fxLayout="column"
      fxLayoutAlign="space-between"
      class="property-bottom-content"
    >
      <h5>
        {{ property.title }}
      </h5>
      <h6>
        {{ property.project.name }}
      </h6>
      <div
        *ngIf="property.property_type == 'apartamente' || property.property_type == 'casevile'"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="property-characteristics"
      >
        <div
          fxFlex="23%"
          class="pc-item room-count-item"
        >
          <div class="pc-item-content">
            {{ property.room_count }}
          </div>
        </div>
        <div
          fxFlex="23%"
          class="pc-item bathroom-count-item"
        >
          <div class="pc-item-content">
            {{ property.bathroom_count }}
          </div>
        </div>
        <div
          fxFlex="23%"
          class="pc-item"
        >
          <div class="pc-item-content">
            {{ property.built_size_sqm | number:'.0-0' }} m<sup>2</sup>
          </div>
        </div>
        <div
          fxFlex="33%"
          class="pc-item"
        >
          <div class="pc-item-content">
            detalii
          </div>
        </div>
      </div>
      <div
        *ngIf="property.property_type == 'terenuri'"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="property-characteristics"
      >
        <div
          fxFlex="50%"
          class="pc-item"
        >
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
          >
            {{ property.land_area_sqm | number:'.0-0' }} m<sup>2</sup>
          </div>
        </div>
        <div
          fxFlex="50%"
          class="pc-item"
        >
          detalii
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template [ngIf]="type === 'project'">
  <div
    [ngStyle]="{'background-image': 'url(' + project.images[0].width_560_url + ')'}"
    class="project-item-image-wrapper"
  >
  </div>
  <label
    *ngIf="project.status !== 'coming_soon'"
    class="project-item-status"
  >
    <ng-template [ngIf]="project.id === 123 || project.id === 119">
      Finalizare 2020
    </ng-template>
    <ng-template [ngIf]="project.id !== 123 && project.id !== 119">
      {{ 'model.project.status.' + project.status | translate }}
    </ng-template>
  </label>
  <div
    class="project-sale-status-wrapper"
  >
    <div
      class="project-sale-status"
      *ngIf="project.status !== 'coming_soon'"
    >
      {{ 'model.project.sale_status.' + project.sale_status | translate }}
    </div>
    <div
      *ngIf="project.status === 'coming_soon'"
      class="project-sale-status"
    >
      în curând
    </div>
  </div>
  <div class="project-item-title-wrapper">
    <h3
      class="project-item-title"
    >
      {{ project.name }}
    </h3>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/shared/property/property.component.html